import Icon, { TIconName } from '../../../Icon';
import { TTreeIconRenderer } from '../types';

const DefaultIconRenderer: TTreeIconRenderer = (props) => {
  return (
    <Icon name={props.icon as TIconName} size={props.iconSize ?? 'iconSm'} />
  );
};

export default DefaultIconRenderer;
